/**
 * Add click source to the CTA, if possible.
 */
export const updateLinkSource = (link: string|null, source: string): string | null => {
  if (link === null) {
    return null;
  }

  try {
    const url = new URL(link);
    url.searchParams.append("source", source);
    return url.toString();
  } catch (e) {
    console.error(`Invalid CTA URL: ${link}`);
    return null;
  }
};
